import { render, staticRenderFns } from "./StickyMenuPopup.vue?vue&type=template&id=1ebbb642&scoped=true"
import script from "./StickyMenuPopup.vue?vue&type=script&lang=js"
export * from "./StickyMenuPopup.vue?vue&type=script&lang=js"
import style0 from "./StickyMenuPopup.vue?vue&type=style&index=0&id=1ebbb642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebbb642",
  null
  
)


    import installDirectives from "!/home/gitlab-runner/builds/_LQxgyuP/0/skolkovo/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBTooltip} from 'bootstrap-vue'
    installDirectives(component, {'b-tooltip': VBTooltip})
    

export default component.exports